import script from "./SignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=18518262&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18518262"]])

export default __exports__